import dynamic from 'next/dynamic';
import type { ReactElement } from 'react';
import { CollectionsPageLayout } from '@members/pg-collections/CollectionsPageLayout';

const Collection = dynamic(
  () => import('@members/class-groups/ClassGroupIndex').then(mod => mod.ClassGroupIndex),
  {
    ssr: false,
  },
);

export default function CollectionsIndexPage() {
  return <Collection />;
}

CollectionsIndexPage.getLayout = function getLayout(page: ReactElement) {
  return <CollectionsPageLayout>{page}</CollectionsPageLayout>;
};
